import React from 'react'
import { TbChartBubble } from "react-icons/tb";
import './IconStyles.css';

export const NodeEffectivenessIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
    <TbChartBubble
        color={props.color ? props.color : undefined}
                   size={props.size ? props.size : "1.25em"}
        // className="globaliconstyles"
    />
    </div>
)